import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#7367F0",
    },
    secondary: {
      main: "#0b0b0b",
    },
    background: {
      default: "#0b0b0b",
    },
  },
  typography: {
    fontFamily: "vaziriFont",
    allVariants: {
      color: "#ffffff",
    },
    h6: {
      fontWeight: 600,
      fontSize: "24px",
    },
    h5: {
      fontWeight: 600,
      fontSize: "32px",
    },
  },
  components: {

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: '#fff',
          fontSize: '14px',
          backgroundColor: '#666666 !important',

          padding: '6px 12px',
          '&::placeholder': {
            color: '#666666',
            opacity: 1,
          },
        },
        root: {
          backgroundColor: '#666666',
          height: 38,
          '& fieldset': {
            borderColor: '#666666',
          },
          '&:hover fieldset': {
            borderColor: '#7367F0',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#7367F0',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          fontSize: '14px',
          '&.Mui-focused': {
            color: '#7367F0',
          },
        },
      },
    },
  },
});

export default theme;
